export const getDataNames = {
  boardLists: 'boardLists',
  workerPositions: 'workerPositions',
  positionsList: 'positionsList',
  permissionsListData: 'permissionsListData',
  boardListsToSelect: 'boardListsToSelect',
};
